<template>
  <div>
      <div>
        <h4>Investor Details</h4>
        <p>User ID: {{ profileSummary.id === 0 ? '' : profileSummary.id }}</p>
        <p>First Name: {{ profileSummary.first_name }} </p>
        <p>Last Name: {{ profileSummary.last_name }} </p>
        <p>Email: {{ profileSummary.email }} </p>
      </div>
    <div>
      <p>{{ savedItemType }}</p>
    </div>
      <div>
        <label v-if="showResMessage">{{ resMessage }}</label>
        <br/>
        <div class="form-group">
          <p>Logging in as the investor will take you away from this page. <br/>Please invite the investor first.</p>
          <button type="submit" class="btn btn-primary btn-md center-block margin-top-20 pull-left" :disabled="disableBtn" @click.prevent="inviteInvestor">Invite Investor</button>
          <modal-help>Send an offering invite to the investor. The investor will be asked to create a password after clicking the link in the email.</modal-help>
        </div>
        <br/><br/>
        <div class="form-group">
          <button type="submit" class="btn btn-primary btn-md center-block margin-top-20 pull-left" :disabled="disableLoginBtn" @click.prevent="logInAsInvestor">LogIn As Investor</button>
          <modal-help>This is a one time login and expires in one hour. Once expired the investor will need to use the forgot password link to reset their password.</modal-help>
        </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
import ModalHelp from "../ModalHelp";

export default {
  components: {ModalHelp},
  props: {
    profileSummary: {
      type: Object,
      default: () => {
       return {
         id: 0,
         first_name: '',
         last_name: '',
         email: '',
       }
      }
    },
    savedOffering: {
      type: Object,
      default: () => {
        return {
          id: 0,
          name: '',
          slug: ''
        }
      }
    },
    savedDocFlow: {
      type: Object,
      default: () => {
        return {
          id: 0,
          slug: '',
        }
      }
    }
  },
  data() {
    return {
      payload: {
        investor_id: 0,
        offering_id: 0,
        doc_flow_id: 0,
        is_create_investor: true,
      },
      resMessage: '',
      showResMessage: false,
      disableLogin: true,
    }
  },
  methods: {
    inviteInvestor() {
      this.payload.investor_id = this.profileSummary.id
      this.payload.offering_id = this.savedOffering.id
      this.payload.doc_flow_id = this.savedDocFlow.id
      if(this.savedOffering.id > 0) {
        return this.inviteInvestorToOffering()
      }
      if(this.savedDocFlow.id > 0) {
        return this.inviteInvestorToFlow()
      }
    },
    inviteInvestorToFlow() {
      axios.post('investor/flow_invite',this.payload).
      then(response => {
        this.resMessage = response.data.statusMessage
        this.showResMessage = true
        return Promise.resolve()
      })

    },
    inviteInvestorToOffering() {
      axios.post('investor/invite',this.payload).
      then(response => {
        this.resMessage = response.data.statusMessage
        this.showResMessage = true
        return Promise.resolve()
      })
    },
    logInAsInvestor() {
      this.payload.investor_id = this.profileSummary.id
      this.payload.offering_id = this.savedOffering.id
      axios.post('investor/otp',this.payload).
          then(response => {
            if(response.data.status === 'success') {
              const offeringSlug = response && response.data && response.data.emdSlug;
              if (offeringSlug) {
                let currentPath = window.location.pathname
                // redirect to the offering page
                let newPath = currentPath.replace(/\/admin\/.*\/investor/, '')
                window.location.href = `${newPath}/${offeringSlug}/data-room`
              } else {
                window.location.href = '/'
              }
      
            }
            if(response.data.status === 'error') {
              this.resMessage = response.data.statusMessage
              this.disableLogin = true
              this.showResMessage = true
            }
          return Promise.resolve()
      })
    },
  },
  computed: {
    disableBtn() {
      return this.savedOffering.id <= 0 && this.savedDocFlow.id <= 0
    },
    disableLoginBtn() {
      return this.savedOffering.id <= 0 && this.disableLogin
    },
    savedItemType() {
      if(this.savedOffering.id > 0) {
        return 'Selected Offering: ' + this.savedOffering.name
      }
      if(this.savedDocFlow.id > 0) {
        return 'Selected Document Flow: ' + this.savedDocFlow.slug
      }
    },
  },
}
</script>